<div class="pkt-form-field" [class.pkt-error-state]="hasError || !!errorMessage" [class.pkt-disabled]="disabled"
  [class.pkt-collapsed]="isCollapsed" [ngClass]="'pkt-label-' + labelPosition">
  <label *ngIf="label && !isCollapsed" class="pkt-label" [class.pkt-label--clamp]="labelLines" [style.--pkt-label-lines]="labelLines">
    {{ label }}<span *ngIf="required" class="pkt-required">*</span>
  </label>

  <!-- Collapsed search: icon-only trigger that expands into the full input on click -->
  <button *ngIf="isCollapsed" type="button" class="pkt-search-trigger" (click)="expand()" [disabled]="disabled">
    <span class="material-symbols-outlined">{{ prefixIcon || 'search' }}</span>
  </button>

  <div *ngIf="!isCollapsed" class="pkt-input-wrapper" [class.has-prefix]="prefixIcon"
    [class.has-suffix]="hasSuffixAction || !!suffixText || (type === 'search' && value)">
    <span *ngIf="prefixIcon" class="pkt-prefix-icon material-symbols-outlined">{{ prefixIcon }}</span>

    <input #searchInput class="pkt-input" [class.pkt-no-spinner]="type === 'number' && !showNumberSpinner"
      [type]="effectiveType" [placeholder]="placeholder" [disabled]="disabled"
      [attr.readonly]="readonly || null" [attr.maxlength]="maxLength || null" [attr.min]="min ?? null"
      [attr.max]="max ?? null" [attr.step]="step ?? null" [attr.autocomplete]="autocomplete" [value]="value"
      (input)="onInputChange($event)" (blur)="onBlur()" (focus)="onFocus()" />

    <button *ngIf="type === 'search' && value" class="pkt-clear-btn" type="button" (click)="onClear()" [tabIndex]="-1">
      <span class="material-symbols-outlined">close</span>
    </button>

    <span *ngIf="suffixText && !hasSuffixAction" class="pkt-suffix-text">{{ suffixText }}</span>

    <button *ngIf="hasSuffixAction" class="pkt-suffix-icon-btn" type="button" (click)="onSuffixClick()"
      [disabled]="disabled" [tabIndex]="-1">
      <span class="material-symbols-outlined">{{ resolvedSuffixIcon }}</span>
    </button>

    <div *ngIf="errorMessage && errorDisplay === 'floating'" class="pkt-error-floating" role="alert">
      <span class="material-symbols-outlined">error</span>{{ errorMessage }}
    </div>
  </div>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage && errorDisplay === 'inline'" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>